import React from "react";
import { Pagination } from "react-bootstrap";

const buildPageList = (currentPage, totalPaginas, siblingCount = 1) => {
    const totalShown = siblingCount * 2 + 5;

    if (totalPaginas <= totalShown) {
        return Array.from({ length: totalPaginas }, (_, i) => i + 1);
    }

    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPaginas);

    const showLeftDots = leftSiblingIndex > 2;
    const showRightDots = rightSiblingIndex < totalPaginas - 1;

    if (!showLeftDots && showRightDots) {
        const leftRange = Array.from({ length: 3 + siblingCount * 2 }, (_, i) => i + 1);
        return [...leftRange, "...", totalPaginas];
    }

    if (showLeftDots && !showRightDots) {
        const rightRange = Array.from(
            { length: 3 + siblingCount * 2 },
            (_, i) => totalPaginas - (3 + siblingCount * 2) + 1 + i
        );
        return [1, "...", ...rightRange];
    }

    const middleRange = Array.from(
        { length: rightSiblingIndex - leftSiblingIndex + 1 },
        (_, i) => leftSiblingIndex + i
    );
    return [1, "...", ...middleRange, "...", totalPaginas];
};

export function FooterPagination({ pagina, totalPaginas, onIr, disabled = false }) {
    const current = Number(pagina);            
    const total = Number(totalPaginas);

    if (total <= 1) return null;

    const pages = buildPageList(current, total, 1);

    return (
        <div className="LStudio__app_container_paginador_wrap mt-3">
            <Pagination className="LStudio__app_content_paginador mb-0">
                <Pagination.Prev disabled={disabled || current === 1} onClick={() => !disabled && onIr(current - 1)} />

                {pages.map((p, i) =>
                    p === "..." ? (
                        <Pagination.Ellipsis key={`ellipsis-${i}`} disabled />
                    ) : (
                        <Pagination.Item key={p} active={p === current} disabled={disabled} onClick={() => !disabled && onIr(p)}>
                            {p}
                        </Pagination.Item>
                    )
                )}

                <Pagination.Next disabled={disabled || current === total} onClick={() => !disabled && onIr(current + 1)} />
            </Pagination>
        </div>
    );
}